import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'sweetalert2-react';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import axios from 'axios';
import { API_URL } from '../../lib/const';
import BaseEnrollmentSummary from './BaseEnrollmentSummary';
import ConfirmationModal from '../components/ConfirmationModal';
import ComponentWithToken from '../components/CompontentWithToken';
import { Spinner } from '../elements';

class EnrollmentSummaryForm extends ComponentWithToken {
  state = {
    showError: false,
    data: {},
    loading: true,
    isModalOpen: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  showModal() {
    this.setState({ isModalOpen: true });
  }

  hideModal() {
    this.setState({ isModalOpen: false });
  }

  fetchData() {
    axios
      .get(`${API_URL}/onboarding/personal-data/${this.token}/summary`)
      .then((response) => {
        this.setState({
          data: response.data,
          loading: false,
        });
      });
  }

  handleSubmit() {
    this.setState({ submitting: true, isModalOpen: false });
    axios
      .post(`${API_URL}/onboarding/enrollments/${this.token}/confirm`)
      .then((response) => {
        this.setState({
          show: true,
          showSuccess: true,
          showError: false,
          submitting: false,
          confirmMessage: get(response, 'data.detail'),
        });
      })
      .catch((error) => {
        this.setState({
          show: true,
          showError: true,
          submitting: false,
          confirmMessage:
            get(error, 'response.data.detail') || 'Ocorreu um erro',
        });
      });
  }

  render() {
    const {
      showSuccess,
      confirmMessage,
      show,
      showError,
      data,
      loading,
      isModalOpen,
      submitting,
    } = this.state;

    const { backClick, onClick } = this.props;
    console.log(data);

    return (
      <Spinner active={submitting}>
        <BaseEnrollmentSummary token={this.token} />
        <hr />
        <div className="text-right" style={{ marginBottom: '2.5rem' }}>
          <div className="col-md-4 p-0 offset-md-8 col-sm-12">
            <div className="btn-actions">
              {!showSuccess &&
                !loading &&
                (get(data, 'enrollment.status.id') === 1 ||
                  get(data, 'enrollment.status.id') === 3) && (
                  <button
                    className="btn btn-black mr-2"
                    disabled={showError || submitting}
                    type="submit"
                    onClick={() => backClick()}
                  >
                    Voltar
                  </button>
                )}
              {!showSuccess &&
                !loading &&
                (get(data, 'enrollment.status.id') === 1 ||
                  get(data, 'enrollment.status.id') === 3) && (
                  <button
                    className="btn btn-primary"
                    disabled={showError || submitting}
                    type="button"
                    onClick={() => this.setState({ isModalOpen: true })}
                  >
                    Enviar para Análise
                  </button>
                )}
              {onClick &&
                !loading &&
                (get(data, 'enrollment.status.id') === 2 ||
                  get(data, 'enrollment.status.id') === 4) && (
                  <button
                    className="btn btn-primary"
                    disabled={showError || submitting}
                    type="submit"
                    onClick={() => onClick()}
                  >
                    Próximo
                  </button>
                )}
            </div>
          </div>
        </div>
        <SweetAlert
          show={show}
          type={showSuccess ? 'success' : 'error'}
          text={confirmMessage}
          onConfirm={
            showSuccess ? onClick : () => this.setState({ show: false })
          }
        />
        <ConfirmationModal
          visible={isModalOpen}
          title="Confirmação"
          onCancel={() => this.hideModal()}
          onConfirm={() => this.handleSubmit()}
        >
          Você confirma o envio dos dados preenchidos para análise do setor{' '}
          {get(data, 'enrollment.kind') === 'enroll_excess'
            ? 'acadêmico'
            : 'financeiro'}
          ?
        </ConfirmationModal>
      </Spinner>
    );
  }
}

EnrollmentSummaryForm.propTypes = {
  backClick: PropTypes.func,
  onClick: PropTypes.func,
};

EnrollmentSummaryForm.defaultProps = {
  backClick: () => {},
  onClick: undefined,
};

export default withRouter(EnrollmentSummaryForm);
